module.exports = __webpack_public_path__ + "img/hb-title.60fb6f6e.png";